export default __webpack_public_path__ + "static/media/triobanner.b775a455.png";